export const validateEmailSend = (
  recipients: { email: string; name?: string; id?: number }[],
  pageType: string,
  dateRange: { from: number|null; to: number|null }
): { valid: boolean; error?: string; validRecipients?: { email: string; name?: string; id?: number }[] } => {
  const list = recipients ?? [];
  const missingEmailRecipients = list.filter((r) => !r?.email || !String(r.email).trim());
  if (missingEmailRecipients.length > 0) {
    const missingNames = missingEmailRecipients.map((r) => r.name || 'unnamed').join(', ');
    let errorMessage = '';
    if (missingEmailRecipients.length === 1) {
      errorMessage = `Please update email address for recipient: ${missingNames} and send again.`;
    } else {
      errorMessage = `Multiple recipients are missing email addresses: ${missingNames}. Please update or remove these recipients to send mail.`;
    }
    return {
      valid: false,
      error: errorMessage,
      validRecipients: list.filter((r) => r?.email && String(r.email).trim()),
    };
  }

  if ((pageType === 'customer' || pageType === 'supplier' || pageType === 'vendor') && (!dateRange.from || !dateRange.to)) {
    return {
      valid: false,
      error: 'Start Date and End Date are required. Please select a date range.',
    };
  }

  return { valid: true };
};
